import {
  BarcodeCaptureSettings,
  Symbology
} from "@scandit/web-datacapture-barcode";
import {
  AimerViewfinder,
  RectangularViewfinder
} from "@scandit/web-datacapture-core";
import type { BarcodeCaptureOverlay } from "@scandit/web-datacapture-barcode";

type ScanditSettings = {
  scandit: {
    scannerLicenseKey?: string;
    scannerEngine?: string;
    viewfinder: "aimer" | "rectangular";
    enabledSymbologies: Symbology[];
    codeDuplicateFilter: number;
  };
};

export interface Settings {
  readonly scandit: ScanditSettings;
  readonly firebase: FirebaseSettings;
  readonly mapBox: MapboxSettings;
}

export interface FirebaseSettings {
  readonly apiKey: string;
  readonly authDomain: string;
  readonly projectId: string;
  readonly storageBucket: string;
  readonly messagingSenderId: string;
  readonly appId: string;
  readonly clientEmail?: string;
}

export interface MapboxSettings {
  readonly mapBoxAccessToken: string;
}

export class GlobalSettings {
  settings: ScanditSettings = {
    scandit: {
      viewfinder: "aimer",
      enabledSymbologies: [
        Symbology.EAN8,
        Symbology.EAN13UPCA,
        Symbology.Code128
      ],
      codeDuplicateFilter: -1
    }
  };

  set(value: Partial<ScanditSettings>) {
    this.settings = {
      ...this.settings,
      ...value,
      scandit: { ...this.settings.scandit, ...value.scandit }
    };
  }

  buildBarcodeCaptureSettings(): BarcodeCaptureSettings {
    const s = new BarcodeCaptureSettings();
    s.enableSymbologies(this.settings.scandit.enabledSymbologies);
    s.codeDuplicateFilter = this.settings.scandit.codeDuplicateFilter;
    return s;
  }

  async applyOverlayUi(overlay: BarcodeCaptureOverlay) {
    if (this.settings.scandit.viewfinder === "rectangular") {
      await overlay.setViewfinder(new RectangularViewfinder());
    } else {
      await overlay.setViewfinder(new AimerViewfinder());
    }
  }
}

const nestedObjectAssign = (target: any, source: any) => {
  Object.keys(source).forEach(sourceKey => {
    if (typeof source[sourceKey] === "object") {
      target[sourceKey] = nestedObjectAssign(
        target[sourceKey] || {},
        source[sourceKey]
      );
    } else {
      target[sourceKey] = source[sourceKey];
    }
  });

  return target;
};

export const globalSettings = new GlobalSettings();
